<kendo-dialog-titlebar>
  <div>{{ templateName }} - {{ 'Operative.Activities' | translate }}</div>
</kendo-dialog-titlebar>

<kendo-grid [data]="activities()"  size="small" [loading]="loading()"
            [pageSize]="state.take"
            [skip]="state.skip"
            [filter]="state.filter"
            [filterable]="true"
            [pageable]="true"
            [resizable]="true"
            [height]="700"
            (dataStateChange)="dataStateChange($event)"
  >
  <kendo-grid-column field="code" title="{{ 'Operative.ActivityCode' | translate }}" >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [showOperators]="false" [column]="column" [filter]="filter">
        </kendo-grid-string-filter-cell>
      </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="description" title="{{ 'Operative.ActivityDescription' | translate }}">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [showOperators]="false" [column]="column" [filter]="filter">
        </kendo-grid-string-filter-cell>
      </ng-template>
  </kendo-grid-column>


</kendo-grid>
